import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  const [expandedFAQ, setExpandedFAQ] = useState(null);

  // Hero Banner Section
  const HeroBannerSection = () => (
    <section className="py-20 bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img 
          src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1920" 
          alt="Network" 
          className="w-full h-full object-cover"
        />
      </div>
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          Drive Business Impact with Our <span className="text-green-500">Technology Services</span>
        </h1>
        <p className="text-white text-lg max-w-3xl">
          <span className="text-green-500">Plexgate</span> helps businesses grow with powerful & user-oriented technology services, designed to improve operational efficiency and drive digital transformation.
        </p>
      </div>
    </section>
  );

  // Main Services Section
  const MainServicesSection = () => {
    const services = [
      {
        id: 'application-development',
        slug: '/services/application-development',
        title: 'Application Development',
        description: 'From mobile apps to enterprise-level software, we specialize in crafting custom applications that enhance productivity and user engagement. Our team uses the latest technologies and frameworks to build scalable, secure applications tailored to your business needs.',
        image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop'
      },
      {
        id: 'cybersecurity-services',
        slug: '/services/cybersecurity-services',
        title: 'Cybersecurity Services',
        description: 'Protect your business from online threats with our comprehensive cybersecurity solutions. We conduct thorough security audits, implement threat detection systems, ensure data protection, and help you maintain compliance with industry standards and regulations.',
        image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=600&h=400&fit=crop'
      },
      {
        id: 'web-development',
        slug: '/services/web-development',
        title: 'Web Development',
        description: 'We create dynamic, user-friendly, and responsive websites tailored to your business needs. Our web development services include responsive design, e-commerce solutions, CMS development, and ongoing website maintenance to ensure your online presence stays strong.',
        image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=600&h=400&fit=crop'
      },
      {
        id: 'it-desktop-support',
        slug: '/services/it-desktop-support',
        title: 'IT/Desktop Support',
        description: 'Reliable IT support services ensuring minimal downtime and maximum productivity. Our 24/7 support team provides help desk services, system maintenance, and troubleshooting to keep your technology infrastructure running smoothly.',
        image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=600&h=400&fit=crop'
      },
      {
        id: 'cloud-solutions',
        slug: '/services/cloud-solutions',
        title: 'Cloud Solutions',
        description: 'Scalable and secure cloud-based solutions for your business infrastructure. We help you migrate to the cloud, manage cloud storage, implement cloud security measures, and optimize your infrastructure for performance and cost-efficiency.',
        image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&h=400&fit=crop'
      },
      {
        id: 'it-consultation-auditing',
        slug: '/services/it-consultation-auditing',
        title: 'IT Consultation & Auditing',
        description: 'Empower your organization with expert guidance and transparent insights. Our consultants develop IT strategies, conduct comprehensive system audits, provide technology consulting, and optimize performance to align your technology with business goals.',
        image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop'
      },
      // {
      //   id: 'creative-design',
      //   slug: '/services/creative-design',
      //   title: 'Creative Design',
      //   description: 'Create compelling web designs using UI/UX & design services to improve responsiveness & user experience. Our creative team specializes in graphic designing, UI/UX designing, branding, mobile app designing, web designing, and logo designing.',
      //   image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=600&h=400&fit=crop'
      // },
      {
        id: 'tech-training',
        slug: '/services/tech-training',
        title: 'Tech Training & Certification Guidance',
        description: 'Empowering individuals to break into tech through hands-on training, structured learning paths, and expert guidance on industry-recognized certifications. We provide beginner to advanced tech training, career path guidance, certification roadmaps for AWS, Azure, CompTIA, Google, and more, plus exam preparation support.',
        image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop'
      },
      {
  id: 'tech-recruitment',
  slug: '/services/tech-recruitment',
  title: 'Tech Recruitment & Talent Solutions',
  description: 'We connect skilled tech professionals with the right opportunities through strategic talent sourcing, screening, and placement. Our recruitment services support startups and enterprises with contract and permanent hires, ensuring the right fit for both employers and candidates.',
  image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=600&h=400&fit=crop'
}
    ];

    return (
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          {services.map((service, index) => (
            <div key={index} id={service.id} className={`grid md:grid-cols-2 gap-12 items-center mb-20`}>
              {index % 2 === 0 ? (
                <>
                  {/* Left Content */}
                  <div>
                    <Link to={service.slug}>
                      <h2 className="text-3xl font-bold mb-4 inline-block border-b-4 border-green-500 pb-1 hover:text-green-600 transition-colors cursor-pointer">
                        {service.title}
                      </h2>
                    </Link>
                    <p className="text-gray-600 leading-relaxed mt-4">{service.description}</p>
                  </div>
                  {/* Right Image */}
                  <div>
                    <img
                      src={service.image}
                      alt={service.title}
                      className="rounded-lg shadow-xl w-full h-[400px] object-cover"
                    />
                  </div>
                </>
              ) : (
                <>
                  {/* Left Image */}
                  <div>
                    <img
                      src={service.image}
                      alt={service.title}
                      className="rounded-lg shadow-xl w-full h-[400px] object-cover"
                    />
                  </div>
                  {/* Right Content */}
                  <div>
                    <Link to={service.slug}>
                      <h2 className="text-3xl font-bold mb-4 inline-block border-b-4 border-green-500 pb-1 hover:text-green-600 transition-colors cursor-pointer">
                        {service.title}
                      </h2>
                    </Link>
                    <p className="text-gray-600 leading-relaxed mt-4">{service.description}</p>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </section>
    );
  };

  // Recognized by the Best Section
  const RecognitionSection = () => {
   const partners = [
  { name: 'HP Partner', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/ad/HP_logo_2012.svg' },
  { name: 'Microsoft Partner', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/96/Microsoft_logo_%282012%29.svg' },
  { name: 'Cisco Partner', logo: 'https://upload.wikimedia.org/wikipedia/commons/0/08/Cisco_logo_blue_2016.svg' },
  { name: 'Lenovo Partner', logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b8/Lenovo_logo_2015.svg' },
  { name: 'Dell Partner', logo: 'https://upload.wikimedia.org/wikipedia/commons/8/82/Dell_Logo.png' },
  { name: 'IBM Partner', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg' },
];

    return (
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            {/* Text Section */}
            <div>
              <p className="uppercase text-sm font-bold text-gray-500 mb-2">Who We Are</p>
              <h2 className="text-4xl font-extrabold text-gray-800 mb-4">Recognized by the Best</h2>
              <p className="text-gray-600 leading-relaxed">
                At Plexgate, we pride ourselves on delivering cutting-edge technology solutions trusted by the best in the industry. 
                Our commitment to excellence ensures seamless project delivery, saving our clients time and resources while driving success.
              </p>
            </div>

            {/* Logo Carousel Section */}
            <div className="overflow-hidden">
              <div className="flex gap-4 animate-scroll">
                {/* First set of logos */}
                {partners.map((partner, index) => (
                  <div key={index} className="flex-shrink-0 flex justify-center items-center">
                    <img src={partner.logo} alt={partner.name} className="h-20 w-32 object-contain" />
                  </div>
                ))}
                {/* Duplicate set for seamless loop */}
                {partners.map((partner, index) => (
                  <div key={`duplicate-${index}`} className="flex-shrink-0 flex justify-center items-center">
                    <img src={partner.logo} alt={partner.name} className="h-20 w-32 object-contain" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };

  // Why Choose Our Services Section with Carousel
  const WhyChooseSection = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    
    const reasons = [
      {
        title: 'Cutting-edge Technology',
        description: 'Delivering efficient, scalable, and impactful digital transformation solutions to drive your business forward.'
      },
      {
        title: 'Dedicated Team',
        description: 'Dive deep into your project details & stay in touch with clients throughout the process.'
      },
      {
        title: 'On-Demand Solutions',
        description: 'Build custom software solutions tailored to your business demands & ensure customer satisfaction.'
      },
      {
        title: 'Domain Expertise',
        description: 'In-depth knowledge of various industries, helping us understand unique challenges and provide tailored solutions.'
      },
      {
        title: 'Agile Methodology',
        description: 'Our agile approach ensures flexibility, faster delivery, and continuous improvement throughout the project lifecycle.'
      },
      {
        title: 'Proven Track Record',
        description: 'With 1,250+ successful projects and a 96% client retention rate, we have a history of delivering excellence.'
      }
    ];

    const getVisibleCards = () => {
      const cards = [];
      for (let i = 0; i < 3; i++) {
        const index = (currentSlide + i) % reasons.length;
        cards.push({ ...reasons[index], key: index });
      }
      return cards;
    };

    React.useEffect(() => {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % reasons.length);
      }, 4000);
      return () => clearInterval(interval);
    }, [reasons.length]);

    return (
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">
              Why <span className="text-green-600">Choose</span> Our Services?
            </h2>
          </div>

          <div className="relative">
            <div className="grid md:grid-cols-3 gap-6">
              {getVisibleCards().map((reason) => (
                <div
                  key={reason.key}
                  className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-all duration-500"
                >
                  <h3 className="text-xl font-bold mb-3">{reason.title}</h3>
                  <p className="text-gray-600 text-sm">{reason.description}</p>
                </div>
              ))}
            </div>

            {/* Dots Navigation */}
            <div className="flex justify-center gap-2 mt-8">
              {reasons.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all ${
                    index === currentSlide ? 'bg-gray-900 w-8' : 'bg-gray-400'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  };

  // FAQ Section
  const FAQSection = () => {
    const faqs = [
      {
        question: 'How To Choose A Trusted Technology Partner?',
        answer: 'Look for a partner with proven expertise, transparent communication, a strong portfolio, and positive client testimonials. At Plexgate, we demonstrate our capabilities through our track record of 1,250+ successful projects and 96% client retention rate.'
      },
      {
        question: 'What Is Your Project Delivery Timeline?',
        answer: 'Project timelines vary based on scope and complexity. We provide detailed estimates during initial consultation and follow agile methodology to ensure timely delivery with regular updates throughout the development process.'
      },
      {
        question: 'How Fast Can You Onboard Team Members?',
        answer: 'We can onboard skilled professionals within 1-2 weeks, depending on your specific requirements. Our staff augmentation service ensures you get the right talent quickly to scale your team.'
      },
      {
        question: 'How Will Your Services Help My Business Grow?',
        answer: 'Our services streamline operations, improve efficiency, enhance customer experience, and provide scalable solutions that grow with your business. We focus on delivering measurable ROI through technology.'
      },
      {
        question: 'Do You Provide Ongoing Support and Maintenance?',
        answer: 'Yes, we offer comprehensive 24/7 support and maintenance services to ensure your systems run smoothly. Our IT/Desktop Support team is always available to address any issues promptly.'
      }
    ];

    return (
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">
              Got <span className="text-green-600">Questions?</span> We've Got Answers!
            </h2>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-gray-50 border border-gray-200 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => setExpandedFAQ(expandedFAQ === index ? null : index)}
                  className="w-full px-6 py-4 flex justify-between items-center text-left hover:bg-gray-100 transition-colors"
                >
                  <span className="font-semibold text-lg">{faq.question}</span>
                  <span className="text-2xl text-gray-600">
                    {expandedFAQ === index ? '−' : '+'}
                  </span>
                </button>
                {expandedFAQ === index && (
                  <div className="px-6 py-4 bg-white border-t border-gray-200">
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  };

  // Our Process Section with Carousel
  const ProcessSection = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    
    const steps = [
      {
        number: '01',
        title: 'Tell Us Your Requirements',
        description: 'Share your project needs and goals.'
      },
      {
        number: '02',
        title: 'Get Matched with Experts',
        description: 'We\'ll connect you with the right Angular developers.'
      },
      {
        number: '03',
        title: 'Interview and Select',
        description: 'Assess their skills and choose the perfect fit.'
      },
      {
        number: '04',
        title: 'Kick start Your Project',
        description: 'Begin your development journey with confidence.'
      }
    ];

    const getVisibleCards = () => {
      const cards = [];
      for (let i = 0; i < 4; i++) {
        const index = (currentSlide + i) % steps.length;
        cards.push({ ...steps[index], key: index });
      }
      return cards;
    };

    React.useEffect(() => {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % steps.length);
      }, 4000);
      return () => clearInterval(interval);
    }, [steps.length]);

    return (
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">
              Our <span className="text-green-600">Process</span>
            </h2>
          </div>

          <div className="relative">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {getVisibleCards().map((step) => (
                <div key={step.key} className="relative">
                  <div className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-all duration-500">
                    <div className="bg-blue-900 text-white w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg mb-4">
                      {step.number}
                    </div>
                    <h3 className="text-xl font-bold mb-3">{step.title}</h3>
                    <p className="text-gray-600 text-sm">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Dots Navigation */}
            <div className="flex justify-center gap-2 mt-8">
              {steps.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all ${
                    index === currentSlide ? 'bg-gray-900 w-8' : 'bg-gray-400'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  };

  // CTA Banner Section
  const CTABannerSection = () => (
    <section className="py-16 bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img 
          src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=1920" 
          alt="Team" 
          className="w-full h-full object-cover"
        />
      </div>
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Let's Build Something <span className="text-green-500">Extraordinary Together!</span>
          </h2>
          <p className="text-white text-lg mb-8">
            Ready to transform your business with cutting-edge technology solutions? Share your vision with us and let's create something amazing together!
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-green-500 text-white px-8 py-3 rounded-full hover:bg-green-600 transition-colors font-medium"
          >
            Get Started Now →
          </Link>
        </div>
      </div>
    </section>
  );

  return (
    <div className="services-page">
      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 20s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
      <HeroBannerSection />
      <MainServicesSection />
      <WhyChooseSection />
      <FAQSection />
      <ProcessSection />
      <RecognitionSection />
      <CTABannerSection />
    </div>
  );
};

export default Services;